module.exports = __webpack_public_path__ + "img/监管服务平台.4b47facd.png";